import { useState } from 'react';
import { AiOutlineEye, AiOutlineEyeInvisible, BsFillLockFill, FiMail } from 'react-icons/all';
import { Link } from 'react-router-dom';
import appleIcon from '../../../assets/images/apple.png';
import facebookIcon from '../../../assets/images/facebook.png';
import googleIcon from '../../../assets/images/search.png';
import styles from './Login.module.scss';

const Login = () => {
    const [showPassword, setShowPassword] = useState(false);

    return (
        <div className="container pt-3">
            <div className={styles.authContainer}>
                <div className={styles.auth}>
                    <div className={styles.authNav}>
                        <Link to="/login" className={`${styles.authNavItem} ${styles.activeTab}`}>
                            Sign In
                        </Link>
                        <Link to="/sign-up" className={`${styles.authNavItem} `}>
                            Register
                        </Link>
                    </div>
                    <div className={styles.authTitle}>
                        <h5 className={styles.welcomeTitle}>Welcome to HimelShop! Please login.</h5>
                    </div>
                    <form action="">
                        <div className={styles.inputGroup}>
                            <FiMail className={styles.inputIcon} />
                            <input
                                className={styles.input}
                                type="email"
                                name=""
                                id=""
                                placeholder="Your Email Id or Phone Number"
                            />
                        </div>
                        <div className={styles.inputGroup}>
                            <BsFillLockFill className={styles.inputIcon} />
                            <input
                                className={styles.input}
                                type={showPassword ? 'text' : 'password'}
                                name=""
                                id=""
                                placeholder="Password"
                            />
                            {showPassword ? (
                                <AiOutlineEye
                                    onClick={() => setShowPassword(!showPassword)}
                                    className={styles.showPassword}
                                />
                            ) : (
                                <AiOutlineEyeInvisible
                                    onClick={() => setShowPassword(!showPassword)}
                                    className={styles.showPassword}
                                />
                            )}
                        </div>
                        <div className={styles.inputButton}>
                            <button type="submit">Login</button>
                        </div>
                    </form>
                    <span className={styles.forgetPassword}>Forgot your password?</span>
                    <h5 className={styles.loginWithSocial}>Login With Social Account</h5>
                    <div className={styles.authWith}>
                        <button type="button">
                            <img className="img-fluid" src={facebookIcon} alt="" />
                        </button>
                        <button type="button">
                            <img
                                style={{ width: '26px' }}
                                className="img-fluid"
                                src={googleIcon}
                                alt=""
                            />
                        </button>
                        <button type="button">
                            <img
                                style={{ width: '27px' }}
                                className="img-fluid"
                                src={appleIcon}
                                alt=""
                            />
                        </button>
                    </div>
                    <div className={styles.link}>
                        Don't have any account? <Link to="/sign-up">Sign Up</Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;
